import { useSyncExternalStore } from "react";

/** Whether a CSS media query matches, updated when it changes (ADR-050: breakpoints and `pointer: coarse`). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** From `lg` (1024 px) the layout changes: side navigation, side panel (ADR-050, point 2). */
export const wideLayout = "(min-width: 64rem)";
